import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const LetterHeadUtility = ({ includeYearCode = true }) => {
    const apiUrl = `${process.env.REACT_APP_API}/getAll_LetterHead`;
    const columns = [
        { label: "Letter No", key: "Letter_No" },
        { label: "Letter Date", key: "Letter_Date" },
        { label: "Gov mill code", key: "gov_millcode" },
        { label: "AC NAME", key: "AC_NAME" },
        { label: "CITY", key: "CITY" },
        { label: "SUBJECT", key: "Subject" }
    ];

    return (
        <TableUtility
            title="Letter"
            apiUrl={apiUrl}
            columns={columns}
            rowKey="Letter_No"
            addUrl="/letterHead"
            detailUrl="/letterHead"
            permissionUrl="/letterHeadUtility"
            includeYearCode={includeYearCode}
        />
    );
};

export default LetterHeadUtility;